export default __webpack_public_path__ + "static/media/nav_img_01.c4b12c93.png";